export default "__VITE_ASSET__d225c686__"